module.exports = __webpack_public_path__ + "img/bitsafe.2e2c5179.svg";